var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',[(_vm.visible)?_c('div',{staticClass:"canvas-warning-banner",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }